module.exports = __webpack_public_path__ + "static/media/S3N8-2.164b8a4d.svg";